import LeftMenus from "./leftMenus";
import Logo from "./logo";
import RightMenus from "./rightMenus";
import { AccountValidation, BotBPass, NavLinks, UserMenus } from "./types";
import React, { useEffect, useRef, useState } from "react";
import "./socials.css";
import Logout from "./logout";
import BotBPassNavMenu from "./botbPassNavMenu";
import FounderBadge from "./founderBadge";
import AllCompetitions from "./allCompetitions";
import FeaturedCompetitionsNew from "./featuredCompetitionsNew";
import SpinAWheelNavMenuItemNew from "./spinAWheelNavMenuItemNew";
import PastDueNotification from "./pastDueNotification";
import CancelledNotification from "./cancelledNotification";
import LeaderboardChristmasBadge from "./leaderboardChristmasBadge";
import FeaturedSubscriberCompetitions from "./featuredSubscriberCompetitions";
import { useCompetitionByType } from "@/app/redux/features/categories/selectors";
import FeelingLuckySection from "./feelingLuckySection";

type DesktopHeaderProps = {
  accountValidationContent: AccountValidation;
  userData: UserMenus;
  navMenus: NavLinks[];
  botbPassNavMenu: BotBPass;
  blackFridayLeaderboardNavMenu?: boolean;
  socialContentTop: string;
  isBotBPassHeader: boolean;
  isFounderPage?: boolean;
  isLeaderBoardPage?: boolean;
  isLeaderBoardChristmasPage?: boolean;
  milestoneData: string;
  showPastDueBanner: boolean;
  onSnoozePastDue: () => void;
  showCancelationBanner: boolean;
  onSnoozeCancelation: () => void;
  IsRAFEnabled?: boolean;
};

const isRAFActive = false;
const areSpringPromotionsActive = true;

const HeaderForLargeScreens = ({
  accountValidationContent,
  userData,
  navMenus,
  socialContentTop,
  botbPassNavMenu,
  blackFridayLeaderboardNavMenu,
  isBotBPassHeader,
  isFounderPage,
  isLeaderBoardPage = false,
  isLeaderBoardChristmasPage = false,
  milestoneData,
  showPastDueBanner,
  onSnoozePastDue,
  showCancelationBanner,
  onSnoozeCancelation,
  IsRAFEnabled = false,
}: DesktopHeaderProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const onScrollToCategory = () => {
      setIsHovered(false);
    };
    window.addEventListener("scroll-to-category", onScrollToCategory);

    return () => {
      window.removeEventListener("scroll-to-category", onScrollToCategory);
    };
  }, []);

  const onCompetitionMenuHover = (hoveredMenuTitle: string) => {
    setIsHovered(hoveredMenuTitle === "Competitions");
  };

  const subscriberCategory = useCompetitionByType("subscriberCompetitions");

  const showPromoColumn = Boolean(botbPassNavMenu) || isRAFActive || areSpringPromotionsActive;

  const getSubNavLinks = () => (
    <div
      onMouseLeave={() => setIsHovered(false)}
      className="absolute left-0 w-full bg-[#f5f5f5] border-t border-solid border-[#c7c7c7] z-[1000]">
      {/* Always 3 equal tracks so when the promo column is hidden, Featured + All keep the same
          column width and shift left into the first tracks (empty space remains on the right). */}
      <div className="grid grid-cols-3 gap-5 px-5 py-8 mainSection mx-auto">
        {/* First column — PLAY MORE, PAY LESS */}
        {showPromoColumn && (
          <div className="flex flex-col w-full min-w-0 gap-5">
            {botbPassNavMenu && (
              <div className="flex flex-col gap-5">
                <BotBPassNavMenu navMenuData={botbPassNavMenu} />
                {subscriberCategory ? <FeaturedSubscriberCompetitions /> : null}
              </div>
            )}
            {isRAFActive && <LeaderboardChristmasBadge isPlacedInMenu={true} IsRAFEnabled={IsRAFEnabled} />}
            {areSpringPromotionsActive ? <FeelingLuckySection /> : null}
          </div>
        )}

        {/* Second column — COMPETITIONS WE LOVE */}
        <div className="min-w-0">
          <FeaturedCompetitionsNew />
        </div>

        {/* Third column — ALL COMPETITIONS + MORE FUN AWAITS */}
        <div className="flex flex-col min-w-0 gap-8">
          <AllCompetitions />
          <SpinAWheelNavMenuItemNew userData={userData} />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div
        className={`header-el flex ${isLeaderBoardPage || isLeaderBoardChristmasPage ? "h-[78px]" : "h-[60px]"} px-[1.5rem] relative mainSection mx-auto border-b-[1px] border-solid border-[#ccc]`}
        ref={ref}>
        <LeftMenus
          userData={userData}
          accountValidationContent={accountValidationContent}
          onNavMenuHover={onCompetitionMenuHover}
          topNavLinks={navMenus}
          isBotBPassHeader={isBotBPassHeader}
        />
        <Logo />
        <RightMenus userData={userData} isBotBPassHeader={isBotBPassHeader} milestoneData={milestoneData} />
        {!isBotBPassHeader && userData?.IsAuthenticated && <Logout formOnly={true} />}
        {isFounderPage && (
          <div className={"ml-auto"}>
            <FounderBadge />
          </div>
        )}
        {isLeaderBoardChristmasPage && (
          <div className={"ml-auto flex items-center"}>
            <LeaderboardChristmasBadge IsRAFEnabled={IsRAFEnabled} />
          </div>
        )}
      </div>
      <div className={"relative"}>
        {document.querySelector("#user-notifications-popover") === null && isHovered && getSubNavLinks()}
      </div>
      {showPastDueBanner ? <PastDueNotification onSnooze={onSnoozePastDue} /> : null}
      {!isBotBPassHeader && !showPastDueBanner && showCancelationBanner ? (
        <CancelledNotification onSnooze={onSnoozeCancelation} />
      ) : null}
    </>
  );
};

export default HeaderForLargeScreens;
